<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="px-5 py-3"
              color="bgContact"
              icon="mdi-account-alert"
              inline
            >
              <template
                v-slot:after-heading
              >
                <div class="font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgContact pa-8">
                  {{ title }}
                </div>
              </template>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingContact"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="contact.name"
                        >
                          <v-text-field
                            v-model="contact.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.contact.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:250|email"
                          name="contact.email"
                        >
                          <v-text-field
                            v-model="contact.email"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.contact.email')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="contact.statusPersonId"
                        >
                          <v-select
                            v-model="contact.statusPersonId"
                            :items="statusesPerson"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.contact.statusPersonId')"
                            :error-messages="errors"
                            outlined
                            :loading="loadingStatuses"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:10"
                          name="contact.cellphone"
                        >
                          <v-text-field
                            v-model="contact.cellphone"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.contact.cellphone')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:10"
                          name="contact.telephone"
                        >
                          <v-text-field
                            v-model="contact.telephone"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.contact.telephone')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>
<style>
.bgContact{
  background-color: #023A66 !important;
}
.v-application .secondary--text{
  color: #E2AA12 !important;
  caret-color: #E2AA12 !important;
}
</style>
<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const contactsRespository = repositoryFactory.get('persons')
  const parametersRespository = repositoryFactory.get('parameters')

  export default {
    inject: ['theme'],
    name: 'ContactCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      contact: {
        active: false,
      },
      statusesPerson: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingContact: false,
      formAction: null,
      loadingStatuses: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-contact') : this.$t('modify-contact')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingContact = true
        var id = this.$route.params.id
        contactsRespository.getById(id).then(response => {
          self.loadingContact = false
          self.contact = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingContact = false
          alert(err)
        })
      }
      this.getStatusesPerson()
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.contact,
        }

        if (self.formAction !== 'add') {
          contactsRespository.updatePerson(data, this.contact.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        } else {
          contactsRespository.addPerson(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        }
      },
      getStatusesPerson () {
        var self = this
        self.loadingStatuses = true
        parametersRespository.getStatusesPerson().then(response => {
          self.statusesPerson = response.data.data
          self.loadingStatuses = false
        }).catch(err => {
          self.loadingStatuses = false
          alert(err)
        })
      },
      goToList () {
        this.$router.push({ name: 'contacts' })
      },
    },
  }
</script>
